import * as React from 'react';
import { color } from '@haldi/style-guide';
import classnames from 'classnames';

import { HaldiStickyNote } from '@src/routes/common/components/HaldiStickyNote';
import { IconShape } from '@src/routes/common/icons/IconShape';
import { AppPicture } from '@src/services/app/components/AppPicture';

import styles from './styles.module.css';

export interface AboutPhotosMegProps {
  className?: string;
}

/**
 * @name AboutPhotosMeg
 * @description These "AboutPhotosXxxx" blocks are used to display some
 * photos of a given team member and help with the arrangement of various
 * Stickers and Sticky Notes which are absolutely positioned.
 */
export const AboutPhotosMeg = (props: AboutPhotosMegProps) => {
  const { className } = props;

  // Styles
  const cssComponent = classnames(styles.component, className);

  return (
    <div className={cssComponent}>
      <div className="relative">
        <div className="ui-desktop">
          <AppPicture
            png="/images/rebrand/about-meg-desktop.png"
            webp="/images/webp/about-meg-desktop.webp"
          />
        </div>
        <div className="ui-mobile">
          <AppPicture
            png="/images/rebrand/about-meg-mobile.png"
            webp="/images/webp/about-meg-mobile.webp"
          />
        </div>
      </div>
      <IconShape className={styles.stickerOne} fill={color.white} shape={12} />
      <IconShape className={styles.stickerTwo} fill={color.pine} shape={5} />
      <HaldiStickyNote
        className={styles.sticky}
        fill={color.turmeric}
        flipped={true}
        rotate={-3}
        size="large"
      >
        <div className="text-20 md:p-2x md:text-32">
          Meg our 1st
          <span className="block">skin coach</span>
        </div>
      </HaldiStickyNote>
    </div>
  );
};
